var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart',{staticStyle:{"max-height":"400px","height":"70vh"},attrs:{"option":_vm.option}})
}
var staticRenderFns = []

export { render, staticRenderFns }